import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select
} from "@material-ui/core";

const FilterSelect = ({
  label,
  options,
  value,
  onChange,
}: {
  label: string,
  options: string[],
  value: string[],
  onChange: (event: any) => void,
}): JSX.Element => {

  return (
    <FormControl>
      <InputLabel id="demo-multiple-name-label" className='filter_label_text'>
        {label}
      </InputLabel>
      <Select
        labelId="demo-multiple-name-label"
        id="demo-multiple-name"
        multiple
        value={value}
        onChange={onChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected: any) => selected.join(', ')}
        MenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
          transformOrigin: { vertical: 'top', horizontal: 'right' },
          getContentAnchorEl: null,
        }}
        className='filter-options'
      >
        {options.map((name) => (
          <MenuItem key={name} value={name}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilterSelect